import { css, useTheme } from "@emotion/react";
import clsx from "clsx";
import { useContext } from "react";

import cardComponentContext from "./cardComponentContext";
import Heading from "./Heading.jsx";
import parseStyle from "./parseStyle";
import useThemeProps from "./useThemeProps.jsx";

export default function CardTitle(props) {
  const theme = useTheme();
  props = useThemeProps({ props, name: "CardTitle" });
  let { children, style, ...restProps } = props;
  const { clickable, title } = useContext(cardComponentContext);
  const { Element, props: linkProps } = clickable;

  if (children) {
    // eslint-disable-next-line no-console
    console.warn(
      "<CardTitle>: Do not pass children to <CardTitle>. Use the `title` prop on <Card> instead.",
    );
  }

  if (!title) {
    return null;
  }

  return (
    <Heading
      // ref={titleRef}
      {...restProps}
      css={css`
        ${parseStyle(style, theme)}
      `}
    >
      <Element
        {...linkProps}
        className={clsx("wsui-card-link", linkProps.className)}
        css={css`
          color: inherit;
          text-decoration: inherit;
          position: static !important;
          &:after {
            content: "";
            display: block;
            position: absolute;
            inset: 0;
            z-index: 1;
            /* z-index: -1; */
          }
          &:focus-visible {
            outline: none;
          }
          &.wsui-is-interactive:hover,
          &.wsui-is-interactive:focus-visible {
            text-decoration: underline;
          }
        `}
      >
        {title}
      </Element>
    </Heading>
  );
}
